// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1q39O","name":"Header_name__1HxUM","birthday":"Header_birthday__3CBjI","skeleton":"Header_skeleton__3c1B_"};